import React, { useState, useRef, useEffect } from "react";

const CustomSelect = ({
  options = [],
  placeholder = "Select",
  value,
  onChange,
  width,
  height,
  fontSize,
  optionFontSize,
  disable = false,
  error = false,
  helperText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const handleSelect = (option) => {
    onChange(option); // send selected option to parent
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [highlighted, setHighlighted] = useState(0);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setIsOpen(true);
      setHighlighted((h) => (h + 1) % options.length);
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setIsOpen(true);
      setHighlighted((h) => (h - 1 < 0 ? options.length - 1 : h - 1));
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (isOpen) {
        console.log(options[highlighted]);
        onChange(options[highlighted]);
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    }
    if (e.key === "Escape") {
      setIsOpen(false);
    }
    if (e.key === "Escape") {
      setIsOpen(false);
    }
    if (e.key === "Tab") {
      setIsOpen(false);
    }
  };

  return (
    <div ref={selectRef} className={`relative w-${width} font-poppins`}>
      {/* Select Box */}
      <div
        onClick={() => {
          if (!disable) {
            setIsOpen(!isOpen);
            // if we are about to open, preselect the current value index
            if (!isOpen) {
              const currentIndex = options.findIndex(
                (op) => op.value === value || op.label === value
              );
              setHighlighted(currentIndex >= 0 ? currentIndex : 0);
              setIsOpen(true);
            } else {
              setIsOpen(false);
            }
          }
        }}
        tabIndex={0}
        onKeyDown={handleKeyDown} // we’ll handle keyboard events
        className={`flex justify-between items-center gap-2 ${width} ${height} px-2 py-1 
        rounded-md border cursor-pointer focus:outline-none focus:border-[#142b70]
          ${disable ? "text-[#eee] border-[#999]/30" : ""}
          ${error ? "border-red-500" : "border-[#a48572]/50"}
        `}
      >
        <p
          className={`text-${fontSize} text-[#142b70]/70 ${
            disable && "text-[#999]"
          }`}
        >
          {value
            ? options.find((op) => op.value === value)?.label
            : placeholder}
        </p>
        <svg
          width={16}
          height={17}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`w-4 h-4 transform transition-transform duration-200 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
        >
          <path
            d="M4 6.5L8 10.5L12 6.5"
            stroke="#142b70"
            strokeOpacity="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full h-auto max-h-48 overflow-y-auto bg-white border border-[#a48572]/20 rounded-md shadow-md">
          {options.map((option, idx) => (
            <div
              key={idx}
              onClick={() => handleSelect(option)}
              className={`px-2 py-1 text-${optionFontSize} text-[#142b70] ${
                option.value === value && "bg-[#f5f2f0]"
              }
              ${
                idx === highlighted && "bg-[#f5f2f0]"
              } hover:bg-[#f5f2f0] cursor-pointer`}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
      {error && helperText && (
        <p className="text-xs text-red-600 mt-2">{helperText}</p>
      )}
    </div>
  );
};

export default CustomSelect;
